export const ONBOARDING_APIS = {
  GET_DATA: "host/onboarding/data/get",
  UPDATE_DATA: "host/onboarding/data/update",
  GET_TEMPLATES: "content/funnels/template/list",
  GET_TEMPLATE_DETAILS: "content/funnels/template/details",
  TEMPLATE_SELECT: "content/funnels/template/select",
  GET_MY_FUNNELS_LIST: "content/myfunnels/list",
  GET_MY_TEMPLATE_DETAILS: "content/myfunnels/details",
  UPDATE_MY_TEMPLATE_DETAILS: "content/myfunnels/update",
};
